<template>
  <div>
    <v-dialog v-model="dialog" persistent fullscreen :retain-focus="false" scrollable>
      <v-card>
        <div style="height: 55px">
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="fecharDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title>Resultado da exportação Protheus</v-toolbar-title>
          </v-toolbar>
        </div>

        <v-divider />

        <v-card-text class="px-4 mt-5">
          <template v-if="error && error.errorCode">
            <p class="error--text mb-n1">{{ error.errorMessage }}</p>
          </template>

          <template v-if="resultado">
            <template v-if="resultado.pedidos">
              <span class="subtitle-1 font-weight-medium">Pedidos Gerados</span>

              <ul class="px-3 mt-2">
                <li
                  v-for="item in resultado.pedidos"
                  :key="item"
                  class="green--text"
                >
                  {{ item }}
                </li>
              </ul>
            </template>

            <template v-if="resultado.alterados">
              <v-divider class="my-4" v-show="resultado.pedidos" />

              <span class="subtitle-1 font-weight-medium mb-1">Produtos Alterados</span>

              <table class="w-full table-font-13px personalizacao-tabela">
                <tr>
                  <th class="text-left">Id Produto</th>
                  <th class="text-left">Desc. Produto</th>
                  <th class="text-left">Qtd. Inicial</th>
                  <th class="text-left">Qtd. Final</th>
                </tr>
                <tr v-for="(item, index) in resultado.alterados" :key="`${index}_`">
                  <td>{{ item.produto }}</td>
                  <td>{{ item.descricao.toUpperCase() }}</td>
                  <td>{{ Helpers.formatarValor(item.qtdinicial) }}</td>
                  <td>{{ Helpers.formatarValor(item.qtdfinal) }}</td>
                </tr>
              </table>
            </template>

            <template v-if="resultado.removidos">
              <v-divider class="my-4" v-show="resultado.alterados || resultado.pedidos"/>

              <span class="subtitle-1 font-weight-medium mb-1">Produtos Removidos</span>

              <table class="w-full table-font-13px personalizacao-tabela">
                <tr>
                  <th class="text-left">Id Produto</th>
                  <th class="text-left">Desc. Produto</th>
                  <th class="text-left">Motivo</th>
                </tr>
                <tr v-for="(item, index) in resultado.removidos" :key="`${index}_`">
                  <td>{{ item.produto }}</td>
                  <td>{{ item.descricao.toUpperCase() }}</td>
                  <td>{{ item.obs.toUpperCase() }}</td>
                </tr>
              </table>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogResultadoExportacao",
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    resultado: {
      type: Object,
      requied: false
    },
    error: {
      type: Object,
      required: false
    }
  },
  methods: {
    fecharDialog () {
      const execRelatorio = (this.resultado.pedidos && this.resultado.pedidos.length > 0)

      if (Object.keys(this.resultado).length > 0) {
        this.$emit('pedido-exportado', execRelatorio)
      }

      this.$emit('change-dialog', false)
    },
  }
}
</script>

<style scoped>
.table-font-13px tr td, th {
  font-size: 13px;
}
.personalizacao-tabela tr td {
  /*border-bottom: 1px solid rgba(0,0,0,.05);*/
  border-collapse: collapse;
}
.personalizacao-tabela tr td {
  padding-right: 5px;
}
</style>
